import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	MatPaginatorIntl,
	MatPaginatorModule,
} from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

import { PaginatorIntl } from '../../shared/internationalizations/paginator-intl';
import { SharedModule } from '../../shared/shared.module';

import { BeneficiariesComponent } from './beneficiaries.component';
import { BeneficiaryHistoryComponent } from './beneficiary-history/beneficiary-history.component';
import { AddDependentModalComponent } from './modals/add-dependent-modal/add-dependent-modal.component';
import { BeneficiaryTypeModalComponent } from './modals/beneficiary-type-modal/beneficiary-type-modal.component';
import { BulkActionDialogComponent } from './modals/bulk-action-upload-dialog/bulk-action-upload-dialog.component';
import { ErrorDialogComponent } from './modals/error-dialog/error-dialog.component';
import { PendenciesModalComponent } from './modals/pendencies-modal/pendencies-modal.component';

@NgModule({
	declarations: [
		AddDependentModalComponent,
		BeneficiariesComponent,
		BeneficiaryHistoryComponent,
		BeneficiaryTypeModalComponent,
		BulkActionDialogComponent,
		ErrorDialogComponent,
		PendenciesModalComponent,
	],
	imports: [
		CommonModule,
		MatPaginatorModule,
		MatSortModule,
		MatTableModule,
		SharedModule,
	],
	providers: [{ provide: MatPaginatorIntl, useClass: PaginatorIntl }],
})
export class BeneficiariesModule {}
